module.exports = __webpack_public_path__ + "img/card-3b-report.0fb85c91.svg";